export const Activism = [
    {
        type: "Activism",
        name: "Vegan Activism",
        category: "all",
        author: "",
        description:
            "The most comprehensive verified list of Vegan Activism organizations online for Vegans looking to jump into activism.",
        link: "https://veganactivism.org",
        "": "",
    },
    {
        type: "Activism",
        name: "Connect For Animals",
        category: "all",
        author: "",
        description: "Connect For Animals (CFA) is a platform for people who want to create a better world for animals, starting by ending factory farming. Find events, groups, and like- minded people—and learn how to be more effective at advocating for animals.",
        link: "https://connectforanimals.com",
        "": "",
    },
    {
        type: "Activism",
        name: "Animal Rights Map",
        category: "all",
        author: "",
        description:
            "With over 2,500 groups, browse the largest collection of animal rights activist groups all located in one single map!",
        link: "https://animalrightsmap.org/",
        "": "",
    },
    {
        type: "Activism",
        name: "⭐️ Vegan Hacktivists",
        category: "online",
        author: "",
        description:
            "We're a group of passionate Vegan Activists that volunteer our time and skills to vegan projects.",
        link: "https://veganhacktivists.org",
        "": "",
    },
    {
        type: "Activism",
        name: "Anonymous for the Voiceless",
        category: "local",
        author: "",
        description:
            "An animal rights organization that specializes in educating the public on animal exploitation and fostering highly effective activism communities worldwide.",
        link: "https://www.anonymousforthevoiceless.org",
        "": "",
    },
    {
        type: "Activism",
        name: "Direct Action Everywhere",
        category: "local",
        author: "",
        description:
            "We create empowered networks of nonviolent direct action to force animal rights into the public consciousness.",
        link: "https://www.directactioneverywhere.com/get-active-main#the-movement-1",
        "": "",
    },
    {
        type: "Activism",
        name: "Vegan Activism Organizations",
        category: "",
        author: "",
        description:
            "The most comprehensive verified list of Vegan Activism organizations online for Vegans looking to jump into activism.",
        link: "https://veganactivism.org",
        "": "",
    },
    {
        type: "Activism",
        name: "Etsy Activism Stickers",
        category: "",
        author: "",
        description: "Buy stickers from Etsy",
        link: "https://www.etsy.com/market/vegan_activism_stickers",
        "": "",
    },
    {
        type: "Activism",
        name: "Vegan Activism Community",
        category: "",
        author: "",
        description: "A community of passionate Vegan Activists on reddit",
        link: "https://reddit.com/r/VeganActivism",
        "": "",
    },
    {
        type: "Activism",
        name: "Reddit Activism Guide",
        category: "",
        author: "",
        description: "Learn how to improve your activism on reddit",
        link: "https://veganactivism.org/pages/reddit-activism",
        "": "",
    },
    {
        type: "Activism",
        name: "Vegan.com Activism Guide",
        category: "",
        author: "",
        description: "The official guide to vegan activism from Vegan.com",
        link: "https://www.vegan.com/activism/",
        "": "",
    },
    {
        type: "Activism",
        name: "Vegan Activism Discord",
        category: "",
        author: "",
        description:
            "Join a live chat with many vegan activists to collaborate with",
        link: "https://discord.gg/MFzRHe5",
        "": "",
    },
    {
        type: "Activism",
        name: "More Activism Stickers",
        category: "",
        author: "",
        description: "Buy some more stickers for your vegan activism",
        link: "https://activiststickers.com/",
        "": "",
    },
    {
        type: "Activism",
        name: "Activism Flyers & Pamphlets",
        category: "",
        author: "",
        description: "Print or buy flyers for your vegan activism",
        link: "https://veganactivism.org/resources/example-flyers-brochures-pamphlets-to-print.pdf",
        "": "",
    },
    {
        type: "Activism",
        name: "Example Business Review",
        category: "",
        author: "",
        description:
            "Great experience at a vegan resteraunt or store? Reward them with a review! Please customize the review before posting!",
        link: "https://veganactivism.org/resources/example-business-restaurant-reviews.pdf",
        "": "",
    },
    {
        type: "Activism",
        name: "Example Tweets / Email",
        category: "",
        author: "",
        description:
            "Email or tweet celebs with vegan information to plant some much needed seeds!",
        link: "https://veganactivism.org/resources/example-tweets-email-to-celebs.pdf",
        "": "",
    },
    {
        type: "Activism",
        name: "Example Local Store Email",
        category: "",
        author: "",
        description:
            "Email template to ask your store to carry more vegan options, please customize before posting!",
        link: "https://veganactivism.org/resources/example-email-to-local-stores.pdf",
        "": "",
    },
    {
        type: "Activism",
        name: "Animal Reality Exposed",
        category: "",
        author: "",
        description: "Graphic Videos For Outreach",
        link: "https://foroutreach.com/",
        "": "",
    },
    {
        type: "Activism",
        name: "Animal Justice Academy",
        category: "",
        author: "",
        description:
            "A free, online, self-paced animal activism course with 5000+ members, featuring over 80 teachers/speakers from the worlds of media, politics, grassroots organizing, business, racial justice, nutrition, law, art, food policy, and health and wellness.",
        link: "https://animaljustice.ca/take-action/animal-justice-academy",
        "": "",
    },
    {
        type: "Activism",
        name: "The Animal Rights FAQ",
        category: "",
        author: "",
        description: "Animal Liberation Front",
        link: "https://web.archive.org/web/20170708002444/http://www.animalliberationfront.com/ALFront/FAQs/ARFAQ.htm",
        "": "",
    },
    {
        type: "Activism",
        name: "⭐️ Fast Action Network: Guide",
        category: "",
        author: "",
        description: "Access meaningful and online actions for animals anytime.",
        link: "https://action.thehumaneleague.org/home/",
        "": "",
    },
    {
        type: "Activism",
        name: "Meat The Victims",
        category: "local",
        author: "",
        description:
            "A new generation of the growing community of citizens willing to disobey unjust laws altogether to abolish animal exploitation. Locking down inside the very places the animals are kept hostage and allowing the public to meet the victims of their choices through personal footage.",
        link: "https://meat-the-victims.org",
        "": "",
    },
    {
        type: "Activism",
        name: "The Save Movement",
        category: "local",
        author: "",
        description:
            "The Save Movement is comprised of groups around the world who bear witness of pigs, cows, chickens and other farmed animals en route to slaughter. Our goals are to raise awareness about the plight of farmed animals, to help people become vegan, and to build a mass-based, grassroots animal justice movement.",
        link: "http://thesavemovement.org",
        "": "",
    },
    {
        type: "Activism",
        name: "The Vegan Society",
        category: "all",
        author: "",
        description:
            "The practicalities of volunteering ranges from role to role, but regardless of what you’re doing, volunteering with us will always be meaningful, enjoyable, and well supported. Every project you ever work on will hold value to the charity’s work, and will feed in to the future of veganism.",
        link: "https://www.vegansociety.com/get-involved/volunteering-vegan-society?ref=veganactivism.org",
        "": "",
    },
    {
        type: "Activism",
        name: "Mercy for Animals",
        category: "all",
        author: "",
        description:
            "Your voice, your ideas, and your actions matter in our shared fight to end animal abuse. We are the generation that will empty cages and reform our food system. Join MFA’s global movement of changemakers who organize local events, take online actions, and support our mission in other ways with their skills and passion.",
        link: "https://mercyforanimals.org/action-center?ref=veganactivism.org",
        "": "",
    },
    {
        type: "Activism",
        name: "Challenge 22+",
        category: "online",
        author: "",
        description:
            "If you’ve been vegan for over six months, have patience and empathy for new vegans and the motivation to help make the vegan population grow, you’re exactly what we’re looking for! Our Challenges take place within Facebook groups, and we ask our Challenge mentors to be present in the group on a daily basis. Our goal is around 10 comments or an hour a day (can be dispersed throughout the day).",
        link: "https://db.challenge22.com/mentor-application-form.php?ref=veganactivism.org",
        "": "",
    },
    {
        type: "Activism",
        name: "The Humane League",
        category: "local",
        author: "",
        description:
            "Through quick and simple daily, or weekly, actions you can make a difference—influencing the policies of the world’s biggest companies, demanding legislation, or empowering others to take action and leave animals off their plates.",
        link: "https://thehumaneleague.org/fast-action-network/?ref=veganactivism.org",
        "": "",
    },
    {
        type: "Activism",
        name: "⭐️ 5 Minutes 5 Vegans",
        category: "online",
        author: "",
        description:
            "Our vegan robots are constantly scanning social media, they retweet people we think are looking for help with going Vegan. Below are a bunch of quick-copy resources you can reply with quickly if you'd like. Simply scroll through the lists on the right and talk to the ones that could use a little help!",
        link: "https://5minutes5vegans.org/",
        "": "",
    },
    {
        type: "Activism",
        name: "Vegan Outreach",
        category: "local",
        author: "",
        description:
            "Vegan Outreach is an American grassroots animal advocacy group working to promote veganism through the widespread distribution of printed informational booklets.",
        link: "https://veganoutreach.org/",
        "": "",
    },
    {
        type: "Activism",
        name: "Beyond Animal",
        category: "all",
        author: "",
        description:
            "Build an integrated digital platform with a range of innovative solutions designed to facilitate and enable a transition to animal-free products and services and reduce dependency on animal-derived products and services of businesses and consumers globally.",
        link: "https://beyondanimal.com",
        "": "",
    },
    {
        type: "Activism",
        name: "Factory Farming Awareness Coalition",
        category: "all",
        author: "",
        description:
            "Empowering individuals and communities to end factory farming.",
        link: "https://ffacoalition.org/",
        "": "",
    },
    {
        type: "Activism",
        name: "Phoenix Zones Initiative",
        category: "all",
        author: "",
        description:
            "Advance rights, health, and wellbeing for people, animals, and the planet.",
        link: "https://www.phoenixzonesinitiative.org",
        "": "",
    },
    {
        type: "Activism",
        name: "Animal Ethics",
        category: "all",
        author: "",
        description:
            "We are an antispeciesist organization that promotes respect for all sentient beings.",
        link: "https://www.animal-ethics.org/",
        "": "",
    },
    {
        type: "Activism",
        name: "Animal Outlook",
        category: "all",
        author: "",
        description:
            "Animal Outlook is a national nonprofit 501(c)(3) animal advocacy organization based in Washington, DC.",
        link: "https://animaloutlook.org",
        "": "",
    },
    {
        type: "Activism",
        name: "Vegan Friendly",
        category: "local",
        author: "",
        description:
            'Helping businesses get certified as "vegan friendly" in the UK and Israel.',
        link: "https://vegan-friendly.co.uk/",
        "": "",
    },
    {
        type: "Activism",
        name: "Animal Justice Project",
        category: "all",
        author: "",
        description:
            "Campaigning to end of factory farming and working with activists nationwide to build the capacity, scale, and effectiveness, of the animal rights movement.",
        link: "https://www.animaljusticeproject.com/",
        "": "",
    },
    {
        type: "Activism",
        name: "Animal Equality",
        category: "all",
        author: "",
        description:
            "International organization working with society, governments, and companies to end cruelty to farmed animals.",
        link: "https://animalequality.org/",
        "": "",
    },
    {
        type: "Activism",
        name: "Joined one of these ? Track your activism!  ↓",
        category: "",
        author: "",
        description: "",
        link: "https://activisthub.org",
        "": "",
    },
    {
        type: "Activism",
        name: "Earthling Ed",
        category: "",
        author: "",
        description: "",
        link: "https://www.youtube.com/channel/UCVRrGAcUc7cblUzOhI1KfFg",
        "": "",
    },
    {
        type: "Activism",
        name: "Joey Carbstrong",
        category: "",
        author: "",
        description: "",
        link: "https://www.youtube.com/joeycarbstrong",
        "": "",
    },
    {
        type: "Activism",
        name: "Leah Doellinger",
        category: "",
        author: "",
        description: "",
        link: "https://www.youtube.com/results?search_query=meat+the+victims",
        "": "",
    },
    {
        type: "Activism",
        name: "Humane Hancock",
        category: "",
        author: "",
        description: "",
        link: "https://www.youtube.com/watch?v=VWm8qmvNpOw",
        "": "",
    },
    {
        type: "Activism",
        name: "Peace By Vegan",
        category: "",
        author: "",
        description: "",
        link: "https://www.youtube.com/channel/UCalf6t4VdIx55Ppqpl83oBg",
        "": "",
    },
    {
        type: "Activism",
        name: "James Hoot",
        category: "",
        author: "",
        description: "",
        link: "https://www.youtube.com/user/sunnysidedown04",
        "": "",
    },
    {
        type: "Activism",
        name: "Gary Yourofsky",
        category: "",
        author: "",
        description: "",
        link: "https://www.youtube.com/channel/UCLW0TEV3YEt-J56pYZm-TgA",
        "": "",
    },
    {
        type: "Activism",
        name: "Seb Alex",
        category: "",
        author: "",
        description: "",
        link: "https://www.youtube.com/channel/UCc5zul6LPDi5Hq0aowUNoxw",
        "": "",
    },
    {
        type: "Activism",
        name: "James Aspey",
        category: "",
        author: "",
        description: "",
        link: "https://www.youtube.com/channel/UCcKFPLxaWvKMwbjd5GjhzKg",
        "": "",
    },
    {
        type: "Activism",
        name: "Erin Janus",
        category: "",
        author: "",
        description: "",
        link: "https://www.youtube.com/user/erinsotherstuff",
        "": "",
    },
    {
        type: "Activism",
        name: "Vegan Gains",
        category: "",
        author: "",
        description: "",
        link: "https://www.youtube.com/channel/UCr2eKhGzPhN5RPVk5dd5o3g",
        "": "",
    },
    {
        type: "Activism",
        name: "Brooklynne Palmer",
        category: "",
        author: "",
        description: "",
        link: "https://linktr.ee/beetsbybrooke",
        "": "",
    },
    {
        type: "Activism",
        name: "Christopher Sebestian",
        category: "",
        author: "",
        description: "",
        link: "https://www.christophersebastian.info/",
        "": "",
    },
    {
        type: "Activism",
        name: "Rebecca Doudak",
        category: "",
        author: "",
        description: "",
        link: "https://veganbodegacat.squarespace.com/",
        "": "",
    },
    {
        type: "Activism",
        name: "Iyle Bako",
        category: "",
        author: "",
        description: "",
        link: "https://linktr.ee/iye.loves.life",
        "": "",
    },
    {
        type: "Activism",
        name: "David Ramms",
        category: "",
        author: "",
        description: "",
        link: "https://www.instagram.com/davidramms/",
        "": "",
    },
    {
        type: "Activism",
        name: "Red Pill Pete",
        category: "",
        author: "",
        description: "",
        link: "https://www.youtube.com/channel/UCEqI1PIJOgy9Jr0Vz10I8Nw",
        "": "",
    },
    {
        type: "Activism",
        name: "Vegan Activism Organizations",
        category: "",
        author: "",
        description:
            "The most comprehensive verified list of Vegan Activism organizations online for Vegans looking to jump into activism.",
        link: "https://veganactivism.org",
        "": "",
    },
    {
        type: "Activism",
        name: "Etsy Activism Stickers",
        category: "",
        author: "",
        description: "Buy stickers from Etsy",
        link: "https://www.etsy.com/market/vegan_activism_stickers",
        "": "",
    },
    {
        type: "Activism",
        name: "Vegan Activism Community",
        category: "",
        author: "",
        description: "A community of passionate Vegan Activists on reddit",
        link: "https://reddit.com/r/VeganActivism",
        "": "",
    },
    {
        type: "Activism",
        name: "Reddit Activism Guide",
        category: "",
        author: "",
        description: "Learn how to improve your activism on reddit",
        link: "https://veganactivism.org/pages/reddit-activism",
        "": "",
    },
    {
        type: "Activism",
        name: "Vegan.com Activism Guide",
        category: "",
        author: "",
        description: "The official guide to vegan activism from Vegan.com",
        link: "https://www.vegan.com/activism/",
        "": "",
    },
    {
        type: "Activism",
        name: "Vegan Activism Discord",
        category: "",
        author: "",
        description:
            "Join a live chat with many vegan activists to collaborate with",
        link: "https://discord.gg/MFzRHe5",
        "": "",
    },
    {
        type: "Activism",
        name: "More Activism Stickers",
        category: "",
        author: "",
        description: "Buy some more stickers for your vegan activism",
        link: "https://activiststickers.com/",
        "": "",
    },
    {
        type: "Activism",
        name: "Activism Flyers & Pamphlets",
        category: "",
        author: "",
        description: "Print or buy flyers for your vegan activism",
        link: "https://veganactivism.org/resources/example-flyers-brochures-pamphlets-to-print.pdf",
        "": "",
    },
    {
        type: "Activism",
        name: "Example Business Review",
        category: "",
        author: "",
        description:
            "Great experience at a vegan resteraunt or store? Reward them with a review! Please customize the review before posting!",
        link: "https://veganactivism.org/resources/example-business-restaurant-reviews.pdf",
        "": "",
    },
    {
        type: "Activism",
        name: "Example Tweets / Email",
        category: "",
        author: "",
        description:
            "Email or tweet celebs with vegan information to plant some much needed seeds!",
        link: "https://veganactivism.org/resources/example-tweets-email-to-celebs.pdf",
        "": "",
    },
    {
        type: "Activism",
        name: "Example Local Store Email",
        category: "",
        author: "",
        description:
            "Email template to ask your store to carry more vegan options, please customize before posting!",
        link: "https://veganactivism.org/resources/example-email-to-local-stores.pdf",
        "": "",
    },
    {
        type: "Activism",
        name: "Animal Reality Exposed",
        category: "",
        author: "",
        description: "Graphic Videos For Outreach",
        link: "https://foroutreach.com/",
        "": "",
    },
    {
        type: "Activism",
        name: "Animal Justice Academy",
        category: "",
        author: "",
        description:
            "A free, online, self-paced animal activism course with 5000+ members, featuring over 80 teachers/speakers from the worlds of media, politics, grassroots organizing, business, racial justice, nutrition, law, art, food policy, and health and wellness.",
        link: "https://animaljustice.ca/take-action/animal-justice-academy",
        "": "",
    },
    {
        type: "Activism",
        name: "The Animal Rights FAQ",
        category: "",
        author: "",
        description: "Animal Liberation Front",
        link: "https://web.archive.org/web/20170708002444/http://www.animalliberationfront.com/ALFront/FAQs/ARFAQ.htm",
        "": "",
    },
    {
        type: "Activism",
        name: "⭐️ Fast Action Network: Guide",
        category: "",
        author: "",
        description: "Access meaningful and online actions for animals anytime.",
        link: "https://action.thehumaneleague.org/home/",
        "": "",
    },
    {
        type: "Activism",
        name: "Wikipedia",
        category: "",
        author: "",
        description: "",
        link: "https://en.wikipedia.org/wiki/Animal_Liberation_Front",
        "": "",
    },
    {
        type: "Activism",
        name: "Official Website",
        category: "",
        author: "",
        description: "",
        link: "https://animalliberationfrontline.com/",
        "": "",
    },
    {
        type: "Activism",
        name: "Instagram",
        category: "",
        author: "",
        description: "",
        link: "https://www.instagram.com/animaliberationfront/?hl=en",
        "": "",
    },
    {
        type: "Activism",
        name: "PETA on ALF",
        category: "",
        author: "",
        description: "",
        link: "https://www.peta.org/about-peta/faq/whats-petas-position-on-the-animal-liberation-front-alf/",
        "": "",
    },
    {
        type: "Activism",
        name: "Is ALF making a difference?",
        category: "",
        author: "",
        description: "",
        link: "https://www.youtube.com/watch?v=Wfex9q5q0-Q",
        "": "",
    },
    {
        type: "Activism",
        name: "Take the Liberation Pledge",
        category: "",
        author: "",
        description: "",
        link: "http://www.liberationpledge.com/",
        "": "",
    },
    {
        type: "Activism",
        name: "How Animal Lovers Avoid Getting Totally Depressed",
        category: "Blog",
        author: "",
        description: "",
        link: "https://www.thedodo.com/how-animal-advocates-avoid-getting-totally-depressed-1240500528.html",
        "": "",
    },
    {
        type: "Activism",
        name: "Depression Hotline (U.S.)",
        category: "Resource",
        author: "",
        description: "",
        link: "https://www.psychguides.com/hotlines/depression/",
        "": "",
    },
    {
        type: "Activism",
        name: "Depression Hotline (International)",
        category: "Resource",
        author: "",
        description: "",
        link: "https://togetherweare-strong.tumblr.com/helpline",
        "": "",
    },
    {
        type: "Activism",
        name: "Make A Post On /r/Vegan",
        category: "Forum",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/vegan/",
        "": "",
    },
    {
        type: "Activism",
        name: "Self-Care Assessment PDF worksheet",
        category: "PDF",
        author: "",
        description: "",
        link: "http://socialwork.buffalo.edu/content/dam/socialwork/home/self-care-kit/self-care-assessment.pdf",
        "": "",
    },
    {
        type: "Activism",
        name: "Sustainable Activism and Avoiding Burnout",
        category: "PDF",
        author: "",
        description: "",
        link: "https://www.activist-trauma.net/assets/files/burnout_flyer_rightway.pdf",
        "": "",
    },
    {
        type: "Activism",
        name: "Compassion Fatigue Awareness Project",
        category: "Resource",
        author: "",
        description: "",
        link: "http://www.compassionfatigue.org/",
        "": "",
    },
    {
        type: "Activism",
        name: "Compassion Fatigue Resources List by Jessica Dolce",
        category: "Resource",
        author: "",
        description: "",
        link: "http://jessicadolce.com/resources/",
        "": "",
    },
    {
        type: "Activism",
        name: "Aftershock: Confronting Trauma in a Violent World: A Guide for Activists and Their Allies",
        category: "Book",
        author: "",
        description: "",
        link: "https://www.amazon.com/Aftershock-Confronting-Violent-Activists-Flashpoint/dp/1590561031/ref=sr_1_1?s=books&ie=UTF8&qid=1473000992&sr=1-1&keywords=aftershock+pattrice+jones",
        "": "",
    },
    {
        type: "Activism",
        name: "Trauma Stewardship: An Everyday Guide to Caring for Self While Caring for Others",
        category: "Book",
        author: "",
        description: "",
        link: "https://www.amazon.com/Trauma-Stewardship-Everyday-Caring-Others/dp/157675944X/ref=sr_1_3?s=books&ie=UTF8&qid=1473001191&sr=1-3&keywords=compassion+fatigue",
        "": "",
    },
    {
        type: "Activism",
        name: "What every vegan should know about burnout",
        category: "Blog",
        author: "",
        description: "",
        link: "https://www.havegonevegan.com/2016/09/what-every-vegan-should-know-about-burnout.html",
        "": "",
    },
    {
        type: "Activism",
        name: "Sustainable Activism",
        category: "Resource",
        author: "",
        description: "",
        link: "https://www.idausa.org/campaign/sustainable-activism/",
        "": "",
    },
    {
        type: "Activism",
        name: "Animal Activist Support Line",
        category: "Resource",
        author: "",
        description: "",
        link: "https://www.idausa.org/campaign/sustainable-activism/animal-activist-helpline/",
        "": "",
    },
    {
        type: "Activism",
        name: "⭐️ Vegan Bootcamp",
        category: "30~ days",
        author: "",
        description: "",
        link: "https://veganbootcamp.org",
        "": "",
    },
    {
        type: "Activism",
        name: "Dairy Free Challenge",
        category: "21 days",
        author: "",
        description: "",
        link: "https://www.dairyfreechallenge.com/",
        "": "",
    },
    {
        type: "Activism",
        name: "Challenge 22+",
        category: "22 days",
        author: "",
        description: "",
        link: "https://www.challenge22.com/",
        "": "",
    },
    {
        type: "Activism",
        name: "10 Weeks To Vegan",
        category: "10 weeks",
        author: "",
        description: "",
        link: "https://veganoutreach.org/mc10w/?tracking=VOSite&10w_version=US_Canada",
        "": "",
    },
    {
        type: "Activism",
        name: "Veganuary",
        category: "30 days",
        author: "",
        description: "",
        link: "https://veganuary.com/",
        "": "",
    },
    {
        type: "Activism",
        name: "Sketches / Shorts That Make You Think",
        category: "4 videos",
        author: "",
        description: "",
        link: "https://veganplaylist.org/playlist/sketches-shorts-that-make-you-think",
        "": "",
    },
    {
        type: "Activism",
        name: "Become A Vegan Activist And Save Lives",
        category: "11 videos",
        author: "",
        description: "",
        link: "https://veganplaylist.org/playlist/become-a-vegan-activist-and-save-lives",
        "": "",
    },
    {
        type: "Activism",
        name: "Vegan Music Is Actually A Real Thing",
        category: "11 videos",
        author: "",
        description: "",
        link: "https://veganplaylist.org/playlist/vegan-music-is-actually-a-real-thing",
        "": "",
    },
]
